export default {
  INCLUDE_BPE: {
    ALL_ENTRIES: 'all_entries',
    ENTRIES_WITH_BPE: 'entries_with_bpe',
    ENTRIES_WITHOUT_BPE: 'entries_without_bpe',
    },
   DATE_TYPE: [
      { LABEL: 'Data de Evento', KEY: 'emission' },
      { LABEL: 'Data de Emissão', KEY: 'authorisation' },
    ],
 INCLUDE_BPE_TYPE: [
    { KEY: 'all_entries', LABEL: 'Todas as passagens' },
    { KEY: 'entries_with_bpe', LABEL: 'Passagens com BPE' },
    { KEY: 'entries_without_bpe', LABEL: 'Passagens sem BPE' },
 ],
};
